import React, { useEffect, useState } from 'react'
import iconNotification from "../../assets/media/icon-notification.svg";
import iconSearch from "../../assets/media/icon-search.svg";


import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, getallUser } from '../../store/reducers/userSlice';
import { fetchNotifications } from "../../store/reducers/notificationSlice";
import userImagePlaceholder from "../../assets/media/avatar2.jpg";

const Header = ({ handleSearchInputChange }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const getUserData = useSelector((state) => state.usersdata.getuserdata);
    const notifications = useSelector((state) => state.notifications.notifications);
    const unreadCount = useSelector((state) => state.notifications.unreadCount);

    useEffect(() => {
        if (user?.access_token) {
            dispatch(fetchNotifications({
                accessToken: user.access_token
            }));
        }
    }, [dispatch, user?.access_token]);

    useEffect(() => {
        dispatch(getUser({ userId: user.user.id, userData: { accessToken: user.access_token } }));

        // SECURITY: Add company_id/user_id filter based on user role
        let queryParams = {};
        if (user.user?.user_role === "company_admin" && user.user?.company_id) {
            queryParams.company_id = user.user.company_id;
        } else if (user.user?.user_role === "employee" && user.user?.id) {
            // Employees should only see themselves (or users from their company if needed)
            queryParams.company_id = user.user.company_id;
        }

        dispatch(getallUser({
            authToken: user.access_token,
            queryParams: queryParams
        }));
    }, [dispatch, user, user.user?.user_role, user.user?.company_id, user.user?.id]);
    return (
        <header className="header">
            {/* <div className='searchForm'>
                <input type='text' onChange={handleSearchInputChange} placeholder='Search' />
                <button><img src={iconSearch} alt='' /></button>
            </div> */}
            <div className='notification'>
                <Link to={'/notification'}>
                    <img src={iconNotification} alt='' />
                    <span>{unreadCount}</span>
                </Link>
            </div>
            <Link to={'/profile'}>
                <img className='avatar' src={getUserData.image || userImagePlaceholder} alt='' />
            </Link>
        </header>
    )
}
export default Header